import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./Invitation.css";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  CircularProgress,
  DialogContent
} from "@mui/material";
import {
  setConfirmDialogOpen,
  setDeleteInvitation,
  setActiveTab,
  setInvitedUser,
} from "../../store/Invite/inviteSlice";
import {
  getActiveInvites,
  deactivateInvite,
  addGuest,
  deactivateInvitationByAvatarId,
  generateStaticDemoLink,
  resendInvitation,
} from "../../store/Invite/inviteThunk";
import ActionConfirmation from "../../../../components/ActionConfirmation";
import { useTranslation } from "react-i18next";
import { FIRE_GUEST } from "../../../Map/store/Avatars/AvatarsSlice";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LaunchIcon from "@mui/icons-material/Launch";
import LinkIcon from "@mui/icons-material/Link";
import TagInput from "../TagInput/TagInput.jsx"
const Invitation = ({ onClose }) => {
  const dispatch = useDispatch();
  const initRef = useRef(false);
  const prevTab = useRef(null);
  const [emails, setEmails] = useState([]);
  const [expirationTime, setExpirationTime] = useState(24);
  const [inviteUrl, setInviteUrl] = useState("");
  const [resendLoadingId, setResendLoadingId] = useState(null);

  const {
    loading,
    error,
    invitationList,
    confirmDialogOpen,
    deleteInvitation,
    activeTab,
    invitedUser,
  } = useSelector((state) => state.inviteModal);

  const { t } = useTranslation();
  const { preferredLanguage } = useSelector((state) => state.auth);
  const { mapConfig } = useSelector((state) => state.MapDisplay);
  /* const emailTrimmed = email.trim();
  const isEmailValid = /^[^\s@]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailTrimmed);
  const canSend = isEmailValid && !!expirationTime; */
  useEffect(() => {
    if (!initRef.current) {
      initRef.current = true;
      dispatch(setActiveTab("inviteUser"));
    }
  }, []);

  useEffect(() => {
    if (activeTab === "invitationList" && prevTab.current !== "invitationList") {
      dispatch(getActiveInvites());
    }
    prevTab.current = activeTab;
  }, [activeTab, dispatch]);

  const onDeleteInvitation = (invitation) => {
    dispatch(setConfirmDialogOpen(true));
    dispatch(setDeleteInvitation(invitation));
  };

  const handleDeactivate = () => {
    if (deleteInvitation?.id) {
      dispatch(deactivateInvite({ params: [{ id: deleteInvitation.id }] }));
      dispatch(FIRE_GUEST({
        avatarEmail: deleteInvitation?.email,
      }))
      dispatch(setConfirmDialogOpen(false));
    }
  };

  const handleSendInvite = async () => {
    if (emails.length && expirationTime) {
      let map_id = mapConfig.mapId
      try {
        const action = await dispatch(
          addGuest({
            body: {
              emails:emails.map(e => {return e.email}),
              expirationTime,
              map_id,
              sendEmail: true,
              anonymous: false,
              //  source: "platform",
            },
          })
        );
        setEmails([]);
        setExpirationTime("");
        onClose();

      } catch (e) {
        console.error(e);
      }
    }
  };
  const handleGenerateLink = async () => {
    if (!expirationTime) return;
    const map_id = mapConfig.mapId;
    try {
      const action = await dispatch(
        generateStaticDemoLink({
          body: { map_id },
        })
      );
      const data = action?.payload;
      if (data?.url) {
        setInviteUrl(data.url);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleResend = async (invitation) => {
    try {
      setResendLoadingId(invitation.id);
      await dispatch(resendInvitation({ params: [{ id: invitation.id }] })).unwrap();
      onClose();
    } catch (e) {
      console.error(e);
    } finally {
      setResendLoadingId(null);
    }
  };

  return (
    <>

      <DialogContent className='dialog-content-scroll'>
        <div className="invitation-tabs">
          <button
            onClick={() => dispatch(setActiveTab("inviteUser"))}
            type="button"
            className={`invitation-tab ${activeTab === "inviteUser" ? "active" : ""
              }`}
            style={{ width: "50%" }}
          >
            <span className="material-symbols-outlined">person_add</span>
            {t("invite")}
          </button>
          <button
            onClick={() => {
              if (activeTab !== "invitationList") {
                dispatch(setActiveTab("invitationList"));
              }
            }}
            type="button"
            className={`invitation-tab ${activeTab === "invitationList" ? "active" : ""
              }`}
            style={{ width: "50%" }}
          >
            <span className="material-symbols-outlined">contract</span>
            {t("active_invitations")}
          </button>
        </div>
        <div className="invitation-content">
          {activeTab === "inviteUser" ? (
            <>
              <InputLabel
                id="email-label"
                sx={{ fontSize: "0.875rem", marginTop: "1.25rem", color: "#364152" }}
              >
                {t("email_address")}
              </InputLabel>
              <TagInput
                sourceClass="tag-input-invitations"
                value={emails}
                onChange={setEmails}
                placeholder="Ajouter un email"
                allowCustomEmail={true}
              />
              <InputLabel
                id="time-select-label"
                sx={{ fontSize: "0.875rem", marginTop: "1.25rem", color: "#364152" }}
              >
                {t("expiration_time")}
              </InputLabel>
              <FormControl fullWidth margin="dense" required>
                <Select
                  id="time-select"
                  value={expirationTime}
                  onChange={(e) => setExpirationTime(e.target.value)}
                  inputProps={{ "aria-label": "Durée d’expiration" }}
                  sx={{
                    backgroundColor: "#EEF2F6",
                    borderRadius: "0.5rem",
                    paddingX: 1,
                    paddingY: 0,
                    border: "none",
                    boxShadow: "none",
                    marginBottom: "0.625rem",
                    "& .Mui- .notchedOutline": { border: "none" },
                    "&:hover .Mui- .notchedOutline": { border: "none" },
                    "&.Mui- .Mui- .notchedOutline": { border: "none" },
                  }}
                >
                  <MenuItem value="" disabled>
                    {t("chose_expiration_time")}
                  </MenuItem>
                  <MenuItem value={24}>1 {t("day")}</MenuItem>
                  <MenuItem value={48}>2 {t("days")}</MenuItem>
                  <MenuItem value={72}>3 {t("days")}</MenuItem>
                </Select>
              </FormControl>
              <div className="modal-action invitation-modal-action" style={{ display: "flex", gap: 12, marginTop: 20 }}>
                <Button
                  className="primary-button"
                  onClick={handleSendInvite}
                  variant="contained"
                /* disabled={!canSend} */
                >
                  {t("send_invitation")}
                </Button>
                <Button
                  onClick={handleGenerateLink}
                  variant="outlined"
                  startIcon={<LinkIcon />}
                  disabled={!expirationTime}
                >
                  {t("generate_link") || "Générer lien"}
                </Button>
              </div>

              {/* Champ affichant le lien généré */}
              <InputLabel
                sx={{ fontSize: "0.875rem", marginTop: "1rem", color: "#364152" }}
              >
                {t("invite_link") || "Lien d’invitation"}
              </InputLabel>
              <TextField
                fullWidth
                margin="dense"
                variant="outlined"
                value={inviteUrl}
                placeholder={t("click_generate_to_get_link") || "Cliquez sur « Générer lien »"}
                InputProps={{
                  readOnly: true,
                  sx: { backgroundColor: "#F8FAFC", borderRadius: "0.5rem" },
                  endAdornment: (
                    <div style={{ display: "flex", gap: 8 }}>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => inviteUrl && navigator.clipboard.writeText(inviteUrl)}
                        startIcon={<ContentCopyIcon />}
                        disabled={!inviteUrl}
                      >
                        {t("copy") || "Copier"}
                      </Button>
                      <Button
                        size="small"
                        variant="text"
                        href={inviteUrl || undefined}
                        target="_blank"
                        rel="noreferrer"
                        startIcon={<LaunchIcon />}
                        disabled={!inviteUrl}
                      >
                        {t("open") || "Ouvrir"}
                      </Button>
                    </div>
                  ),
                }}
              />
            </>
          ) : (
            <>
              <h2 className="invitation-title">{t("list_of_active_invitations")}</h2>
              {loading ? (
                <CircularProgress />
              ) : (
                <div className="invitation-list">
                  {invitationList.length > 0 ? (
                    invitationList.map((invitation) => (
                      <div className="invitation-card" key={invitation.id}>
                        <div className="invitation-left">
                          <div className="invitation-text">
                            <p className="invitation-email">
                              {invitation.email?.[0]?.toUpperCase() + invitation.email?.slice(1)}
                            </p>
                            <p className="invitation-expiration">
                              {t("expiration_date")}:{" "}
                              {new Date(invitation.expiration_date).toLocaleDateString(preferredLanguage)}
                            </p>
                          </div>
                        </div>

                        <div className="invitation-actions">
                          <button
                            type="button"
                            className={`invitation-button secondary ${invitation.source !== "platform" ? "disabled" : ""
                              }`}
                            onClick={() => invitation.source === "platform" && handleResend(invitation)}
                            disabled={invitation.source !== "platform" || resendLoadingId === invitation.id}
                            title={
                              invitation.source !== "platform"
                                ? t("resend_only_platform") || "Relance disponible uniquement pour les invitations plateforme"
                                : ""
                            }
                          >
                            {resendLoadingId === invitation.id
                              ? t("sending")
                              : t("resend_invitation")}
                          </button>

                          <button
                            type="button"
                            className="invitation-button"
                            onClick={() => onDeleteInvitation(invitation)}
                          >
                            {t("deactivate")}
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>{t("no_active_invitations")}</p>
                  )}
                </div>
              )}
            </>
          )}
        </div>
        <ActionConfirmation
          open={confirmDialogOpen}
          onClose={() => dispatch(setConfirmDialogOpen(false))}
          onConfirm={handleDeactivate}
          title={t("deactivate_invitation_confirmation_header")}
          msg={t("deactivate_invitation_confirmation_message")}
          variant="destructive"
          cancelText={t("cancel")}
          confirmText={t("deactivate")}
        />
      </DialogContent>
    </>
  );
};

export default Invitation;